import React from 'react';
import { Paper, ClickAwayListener, DialogContent, Modal } from '@mui/material';
import { Close } from '@mui/icons-material';
import styles from './BasicModal.module.css';

export interface BasicModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children?: React.ReactNode;
}

export default function BasicModal({
  open,
  onClose,
  title,
  children = null,
}: BasicModalProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <DialogContent className={styles.modalContainer}>
        <ClickAwayListener onClickAway={onClose} mouseEvent="onMouseDown">
          <div id="confirmation-modal" className={styles.modalInner}>
            <Paper className={styles.modal}>
              <div className={styles.modalTitleContainer}>
                <Close
                  onClick={onClose}
                  fontSize="small"
                  className={styles.modalCloseButton}
                />
                <h1 className={styles.modalTitle}>{title}</h1>
              </div>
              {children}
            </Paper>
          </div>
        </ClickAwayListener>
      </DialogContent>
    </Modal>
  );
}
